import type { CatalogRow } from '@/lib/catalog';
import type { DrinkCategory } from '@/types/data';

function median(values: number[]): number | null {
  if (!values.length) return null;
  const sorted = [...values].sort((a, b) => a - b);
  const mid = Math.floor(sorted.length / 2);
  return sorted.length % 2 === 0
    ? (sorted[mid - 1] + sorted[mid]) / 2
    : sorted[mid];
}

export type CategoryMedians = {
  alcoholPer100Calories: number | null;
  alcoholPerDollar: number | null;
  sampleSizeCal: number;
  sampleSizeDol: number;
};

export function categoryMedians(
  rows: CatalogRow[],
  category: DrinkCategory,
): CategoryMedians {
  const inCat = rows.filter((r) => r.product.category === category);
  const cal = inCat
    .map((r) => r.alcoholPer100Calories)
    .filter((n): n is number => n != null && Number.isFinite(n));
  const dol = inCat
    .map((r) => r.alcoholPerDollar)
    .filter((n): n is number => n != null && Number.isFinite(n));
  return {
    alcoholPer100Calories: median(cal),
    alcoholPerDollar: median(dol),
    sampleSizeCal: cal.length,
    sampleSizeDol: dol.length,
  };
}

export function vsMedianPhrase(
  value: number | null,
  med: number | null,
  higherIsBetter: boolean,
): string | null {
  if (value == null || med == null || !(med > 0)) return null;
  const pct = ((value - med) / med) * 100;
  const abs = Math.abs(pct);
  if (abs < 2) return 'about even with the category median';
  const better =
    (higherIsBetter && pct > 0) || (!higherIsBetter && pct < 0);
  const direction = pct > 0 ? 'above' : 'below';
  return `${abs.toFixed(0)}% ${direction} the category median (${better ? 'favorable' : 'less favorable'} on this axis)`;
}
